var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.85 23.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffeaee;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2.48,9.08c4.58-.16,9.06-.38,13.55-.43,2.3.05,9.15.12,6.02,3.91-.79.87-1.7,1.55-2.93,1.58-5.88-.34-12.04,1.58-17.64-.91C.23,12.66-.18,12.01.07,10.99c.34-1.43,1.08-1.98,2.41-1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6.75,17.76c1.25-.05,2.51-.07,3.75-.12,2.59-.11,5.17-.21,7.76-.3,1.31-.04,2.38.57,3.2,1.53.95,1.11.11,2.95-1.49,3.36-5.6,1.32-11.56,1.76-17.12.11-1.82-.51-2.48-2.29-1.45-3.65.15-.2.38-.42.6-.47,1.56-.29,3.15-.41,4.75-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.46,4.97c-5.38.37-10.84,1.04-16.21.16-.34-.05-.69-.19-1.01-.13-1.27.22-1.6-.61-1.78-1.56-.24-1.22.19-2.22,1.26-2.46C4.37.36,7.06-.12,9.81.42c2.52.07,5.09-.05,7.62-.04.26,0,.54,0,.78-.11.96-.41,1.77-.41,2.62.36,1.66,1.33,1.13,4.92-1.37,4.33Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.ac44b91d1a58e04ee0ca811cea2995bf.svg";
export { ForwardRef as ReactComponent };